module.exports = __webpack_public_path__ + "img/2bc10ff.jpg";